import Cookie from "js-cookie";
import { get } from "lodash";

export const SESSION_COOKIE_KEY = "BulkySession";

//TODO: create the USER interface

export const createSession = (authToken: string, user: any) => {
  Cookie.set(SESSION_COOKIE_KEY, JSON.stringify({ authToken, user }));
};

export const getSessionValue = (key: string, defaultValue?: any) =>
  get(JSON.parse(Cookie.get(SESSION_COOKIE_KEY) || "{}"), key, defaultValue);

export const updateSessionUser = (user: any) => {
  const prevSession = JSON.parse(Cookie.get(SESSION_COOKIE_KEY) || "{}");
  Cookie.set(
    SESSION_COOKIE_KEY,
    JSON.stringify({
      ...prevSession,
      user: { ...prevSession.user, email: user.email, name: user.name },
    })
  );
};

export const destroySession = () => {
  Cookie.remove(SESSION_COOKIE_KEY);
};
